import { SITE } from '../../data/site';

interface SiteBrandProps {
  className?: string;
  variant?: 'nav' | 'footer';
}

export function SiteBrand({ className = '', variant = 'nav' }: SiteBrandProps) {
  return (
    <span className={`site-brand site-brand--${variant} ${className}`.trim()} aria-label={SITE.name}>
      <span className="site-brand__hello">HELLO</span>
      <span className="site-brand__gwiji">GWIJI</span>
    </span>
  );
}
